<script lang="ts">
    import SVGIcon from "$/components/SVGIcon.svelte";
    import ClusterTopicItem from "$/components/pageSelect/components/ClusterTopicItem.svelte";
    import type { Cluster, Topic } from "$/components/pageSelect/types";
    import { ClusterStore, ClusterType } from "$/stores/ClusterStore";

    export let cluster: Cluster;
    export let isMultipleTenants: boolean;
    export let effectivePricingPlan: number;
    export let clusterIndex: number;
    export let topicRefs: Record<string, HTMLElement>;
    export let canAddTopicsToCluster: (cluster: Cluster) => boolean;
    export let addNewClusterPage: (cluster: Cluster) => any;
    export let archiveTopic: (topic: Topic, archive: boolean) => Promise<void>;
    export let optionSelected: (option: Topic) => Promise<void>;
    export let optionEditClicked: (option: Topic) => Promise<void>;
    export let optionArchiveClicked: (option: Topic) => Promise<void>;
    export let optionLeaveClicked: (option: Topic) => Promise<void>;
    export let optionDeleteClicked: (option: Topic) => Promise<void>;

    // hide empty archive and shared clusters if they don't have any topics
    let hideEmptyArchiveAndSharedClusters = false;
    let newHiddenClusters = ["ARCHIVED", "SHARED_WITH_ME"];

    if (
        newHiddenClusters.includes(cluster.clusterType) &&
        cluster.topics.length === 0
    ) {
        hideEmptyArchiveAndSharedClusters = true;
    }

    $: userCanAddTopicsToCluster = canAddTopicsToCluster(cluster);

    $: collapsed = $ClusterStore ? ClusterStore.isCollapsed(cluster) : false;
</script>

{#if !hideEmptyArchiveAndSharedClusters}

    <!--  Moving the Archive cluster to the end was removed so that navigation using arrow keys is possible.  -->
    <div class="cluster-group"
         class:title-to-top={!isMultipleTenants}>
        <div class="cluster-item">
            <button
                class="button"
                on:click={() => ClusterStore.toggleCollapsed(cluster)}
            >
                <div class="svg-wrapper" class:rotated={collapsed}>
                    <SVGIcon name="chevron-down" size={16} />
                </div>
            </button>

            <span class="option__text">{cluster.name}</span>

            {#if userCanAddTopicsToCluster}
                <button
                    class="button"
                    on:click={() => addNewClusterPage(cluster)}
                >
                    <SVGIcon name="plus" size={16} />
                </button>
            {/if}
        </div>

        <div class="topics">
            {#if !collapsed}
                {#each cluster.topics as topic, topicIndex (topic)}
                    <ClusterTopicItem
                        {clusterIndex}
                        {effectivePricingPlan}
                        {topic}
                        {topicIndex}
                        {topicRefs}
                        {archiveTopic}
                        {optionArchiveClicked}
                        {optionDeleteClicked}
                        {optionEditClicked}
                        {optionLeaveClicked}
                        {optionSelected}
                        on:clearSearchTopicsInput
                    />
                {/each}
            {/if}
        </div>
    </div>
{/if}

<style>
    .cluster-group {
        @apply reset flex w-full shrink-0 flex-col items-center justify-start bg-white text-sm font-normal text-gray-600 !important;
    }

    .cluster-item {
        @apply sticky top-0 z-10 box-border flex w-full gap-1.5 bg-gray-200 px-3.5 py-1 !important;
    }

    .cluster-group .option__text {
        @apply w-full flex-1 text-sm font-normal text-gray-600 !important;
    }

    .button {
        @apply reset flex h-5 w-5 cursor-pointer items-center justify-center rounded text-gray-600 transition-all hover:bg-gray-300 !important;
    }

    .topics {
        @apply w-full;
    }

    .svg-wrapper {
        @apply grid place-items-center transition-all !important;
    }

    .svg-wrapper.rotated {
        @apply -rotate-90 !important;
    }
</style>
